<template>
  <div class="loading-wrap" ref="loadingWrap"></div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";
import { checkRoutePath } from "utils/util";
import { get_schema } from "@/utils/ajax";
export default {
  computed: {
    ...mapGetters("global", ["aside"]),
  },
  data() {
    return {
      isBgShowing: false,
      hasBeenFinish: false,
      enterWebsite: "",
    };
  },
  mounted() {
    this.load_data();
  },
  methods: {
    ...mapMutations("global", [
      "updateSchema",
      "updatePreloading",
      "updatePreloadingDone",
    ]),
    async load_data() {
      let globalData = await get_schema("/global");

      Vue.prototype.$TL = globalData.item.translate.data;

      Vue.prototype.$AsideRoute = this.seek_nav_router(
        globalData.item.aside.data
      );

      this.updateSchema({ name: globalData.name, value: globalData });

      //  如果是404 默认跳转到首页
      if (this.$route.name === "pageNotFound") {
        console.log("404 捕获, 重定向到首页");
        this.$router.push({ path: "/" });
      }

      setTimeout(async () => {
        //  加载当前路由对应的API数据
        let currentSchemaPath = checkRoutePath(this.$route.path, this.aside);

        let getCurrentStageData = await get_schema(
          this.get_schema_path(currentSchemaPath)
        );

        this.updateSchema({
          name: this.get_router_name(),
          value: getCurrentStageData,
        });

        this.updatePreloading();
        this.updatePreloadingDone();
      }, 100);

      this.load_fonts();
    },
    /**
     * 中文加载额外的字体
     */
    load_fonts() {
      if (
        document.body.dataset.lang === "zh-TW" ||
        document.body.dataset.lang === "zh-CN"
      ) {
        $("head").append(
          // `<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Noto+Sans+TC:400,500,700&subset=chinese-traditional">`
          `<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Noto+Sans+SC:400,500,700&display=swap&subset=chinese-simplified">`
        );

        // 加载source-han-serif-sc字体
        //  这里的 msp7lrc 是谨严的账号的kitId
        let kitId = "msp7lrc";
        $.getScript(`https://use.typekit.net/${kitId}.js`, () => {
          try {
            Typekit.load({
              kitId,
              // scriptTimeout: 800,
              async: true,
              family: "source-han-serif-sc",
            });
          } catch (e) {}
        });
      }

      //    加载通用的数字字体
      $("head").append(
        '<link href="https://fonts.googleapis.com/css?family=Oxygen:400,700&display=swap" rel="stylesheet">'
      );
    },
    /**
     * 铺开侧边栏导航数据
     */
    seek_nav_router(asideNavData) {
      let asideData = [];
      asideNavData.map((item, i) => {
        item.path = `/${item.slug}`;
        asideData.push(item);
        item.episode = item.episode || item.title;

        if (item.children.length > 1) {
          item.children.map((child, n) => {
            child.episode = item.episode;
            child.path = `${item.path}/${child.slug}`;
            asideData.push(child);
          });
        }
      });
      return asideData;
    },
  },
};
</script>

<style lang="scss">
.loading-wrap {
  z-index: 99999999;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: #fff;
}
</style>
